import { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'react-aria-components';
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons/faRotateRight';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { OldAwesomeFilter } from 'components/custom-icon/OldAwesomeFilter';
import { DownloadCsv } from 'components/app-page/page-toolbar/DownloadCsv';
import { CsvData } from 'components/app-page/page-toolbar/CsvData';



export type PageToolbarProps = {
	pageLabel: string;
	resetPageApi?: VoidFunction | undefined;
	csvData?: CsvData | undefined;
}


export const PageToolbar = memo((props: PageToolbarProps) => {
	const { pageLabel, resetPageApi, csvData } = props;

	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const navigate = useNavigate();
	const hasPermission = useHasPermission();
	
	const handleKeyDown = (event: KeyboardEvent) => {
		if(resetPageApi !== undefined && event.ctrlKey && event.key == "q") {
			resetPageApi();
		}
	};

	
	useEffect(() => {
		// change function reference when date change
		window.addEventListener('keydown', handleKeyDown);
		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		}
	}, [ dateWithoutTime ]);


	return (
		<div className='page-toolbar'>
			
			<p className='page-name'>{pageLabel}</p>

			<div className='page-icons'>

				{csvData !== undefined && csvData !== null &&
					<DownloadCsv csvData={csvData} />}
				
				{resetPageApi !== undefined &&
					<Button>
						<FontAwesomeIcon className="toolbar-icon refresh-icon" icon={faRotateRight} onClick={resetPageApi} />
					</Button>}
				
				{hasPermission(AppRolesEnum.userData_Read) &&
					<Button>
						<OldAwesomeFilter className="toolbar-icon filter-icon" onClick={() => navigate(NavigateRoutesEnum.filter)} />
					</Button>}
			
			</div>
			
		</div>
	);
})